var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeEmpty = function SvgTypeEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126,
    height: 126,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2042_27002)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#F5F4EE",
    rx: 20
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    d: "M88 28.12a8.86 8.86 0 0 1 2.627-3.997 8.65 8.65 0 0 1 4.295-2.014 8.6 8.6 0 0 1 4.699.564 8.73 8.73 0 0 1 3.714 2.976 8.94 8.94 0 0 1 1.638 4.51 9 9 0 0 1-.923 4.715 8.8 8.8 0 0 1-3.21 3.531 8.6 8.6 0 0 1-4.553 1.305v2.213m.109 8.855V51h-.217v-.222z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BF1424",
    clipPath: "url(#clip1_2042_27002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.875 58.825a3.92 3.92 0 0 1 3.697.925l29.496 27.604a3.922 3.922 0 0 1-1.665 6.655l-39.02 10.46a3.92 3.92 0 0 1-3.696-.925L31.19 75.941a3.924 3.924 0 0 1 1.665-6.655zM41.71 75.037l22.747 21.288 30.092-8.067L71.802 66.97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.197 85.62a3.924 3.924 0 0 1 5.546-.183l27.905 26.114 36.914-9.896a3.923 3.923 0 1 1 2.032 7.579l-39.02 10.461a3.93 3.93 0 0 1-3.697-.925L27.381 91.167a3.924 3.924 0 0 1-.184-5.546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.388 100.846a3.924 3.924 0 0 1 5.546-.184l27.904 26.114 36.914-9.896a3.924 3.924 0 0 1 2.032 7.58l-39.02 10.461a3.93 3.93 0 0 1-3.697-.925l-29.495-27.604a3.924 3.924 0 0 1-.184-5.546"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2042_27002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 126,
    fill: "#fff",
    rx: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2042_27002"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m30.072 39.768 91.353 22.857-22.857 91.354-91.354-22.857z"
  })))));
};
export default SvgTypeEmpty;